module.exports = __webpack_public_path__ + "img/logo-primary-white.6c3c6dff.webp";